import {Subject, debounceTime, fromEvent, merge, race, take, throttle, timer} from 'rxjs'
import {Turbo} from '@hotwired/turbo-rails'

const IN_FLIGHT_LIMIT = 15000
const refreshFinished = merge(fromEvent(document, 'turbo:load'), fromEvent(document, 'turbo:fetch-request-error'))

// Refreshes the page at most once per `debounce` ms of quiet and never while a refresh is still in
// flight: updates arriving meanwhile collapse into one follow-up refresh once the current one finishes.
export default function debouncedRefresh(debounce) {
  const subject = new Subject()
  const untilRefreshFinished = () => race(refreshFinished, timer(IN_FLIGHT_LIMIT)).pipe(take(1))

  subject
    .pipe(debounceTime(debounce), throttle(untilRefreshFinished, {leading: true, trailing: true}))
    .subscribe(() => {
      Turbo.cache.clear()
      Turbo.visit(window.location.href, {action: 'replace'})
    })

  return subject
}
